import { PreBook } from 'domains/signupDirect/schemas/preBookSchema';

export const isFormValid = (
  schedulePreference: {
    firstAppointment: { date: string };
    secondAppointment: { date: string };
  } | null | undefined,
  singleSessionOnly: boolean,
  sessionSchedule: PreBook | undefined,
): boolean => {
  // Guard clauses for invalid inputs
  if (!sessionSchedule) {
    return false;
  }

  if (!schedulePreference) {
    return false;
  }

  try {
    // Validate first appointment
    const hasFirstAppointment = Boolean(schedulePreference.firstAppointment?.date);
    if (!hasFirstAppointment) {
      return false;
    }

    // Validate second appointment only if not single session
    if (!singleSessionOnly) {
      const hasSecondAppointment = Boolean(schedulePreference.secondAppointment?.date);
      return hasSecondAppointment;
    }

    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error validating form:', error);
    return false;
  }
};